import {
  ArrowBackIosNewRounded,
  ArrowForwardIosRounded,
  Update,
} from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { useState, useRef, useLayoutEffect, useMemo } from "react";
import classNames from "classnames";

export function TagList(props: {
  tags: Array<{ name: string; value: string }>;
  value?: string;
  className?: string;
  onChange: (v: string) => void;
}) {
  const { tags, className } = props;
  const [translateX, setTranslateX] = useState(0);
  const [maxTranslateX, setMaxTranslateX] = useState(0);
  const containerRef = useRef<HTMLDivElement>(null);
  const listRef = useRef<HTMLUListElement>(null);

  const leftShow = useMemo(() => translateX < 0, [translateX]);
  const rightShow = useMemo(
    () => translateX > -maxTranslateX,
    [translateX, maxTranslateX]
  );

  const handleScroll = (direction: "left" | "right") => {
    const interval = 200;

    if (direction === "left") {
      setTranslateX((prev) => Math.min(0, prev + interval));
    } else {
      setTranslateX((prev) => Math.max(-maxTranslateX, prev - interval));
    }
  };

  const update = (v: string) => {
    const value = props.value || "";
    const newValue = v === value ? "" : v;
    // if (value.includes(v)) {
    //   const index = value.findIndex((item) => item === v);
    //   if (index !== -1) {
    //     value.splice(index, 1);
    //   }
    // } else {
    //   value.push(v);
    // }
    props.onChange(newValue);
  };

  useLayoutEffect(() => {
    const padding = 48;

    if (containerRef.current && listRef.current) {
      setMaxTranslateX(
        listRef.current.scrollWidth -
          containerRef.current.clientWidth +
          padding * 2
      );
    }
  }, []);

  return (
    <div ref={containerRef} className={classNames("relative", className)}>
      {leftShow && (
        <span
          className="z-10 cursor-pointer rounded-full  p-2 absolute left-0 top-1/2 -translate-y-1/2 bg-white hover:bg-white hover:shadow"
          onClick={() => handleScroll("left")}
        >
          <ArrowBackIosNewRounded />
        </span>
      )}
      {rightShow && (
        <span
          className="z-10 cursor-pointer rounded-full p-2 absolute right-0 top-1/2 -translate-y-1/2 bg-white hover:bg-white hover:shadow"
          onClick={() => handleScroll("right")}
        >
          <ArrowForwardIosRounded />
        </span>
      )}
      <ul
        ref={listRef}
        className="flex gap-x-3 transition-transform"
        style={{ transform: `translateX(${translateX}px)` }}
      >
        {tags.map((tag, index) => (
          <li
            key={index}
            onClick={() => update(tag.value)}
            className={
              "" +
              (props.value === tag.value ? " font-bold bg-red-100 " : "") +
              " cursor-pointer hover:text-red-500 rounded-xl px-4 text-nowrap leading-8 text-neutral-500"
            }
          >
            {tag.name}
          </li>
        ))}
      </ul>
    </div>
  );
}
